import { Anchor } from "lucide-react";
import { useLang } from "@/i18n";
import { COMPANY } from "@/data";

export const Footer = () => {
  const { t } = useLang();
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer className="border-t border-white/10 bg-abyss" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 bg-white flex items-center justify-center rounded-sm p-1 shadow-[0_0_22px_rgba(45,212,160,0.4)]"><img src="/logo.png" alt="Sodimax Logistics" className="w-full h-full object-contain" /></span>
            <span className="font-display font-semibold tracking-wide text-lg uppercase">Sodimax Logistics</span>
          </div>
          <p className="mt-6 text-steel-400 text-sm leading-relaxed max-w-sm">{t("footer.tagline")}</p>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-widest text-steel-500 mb-5">{t("footer.nav")}</p>
          <div className="space-y-3">
            {[["about", t("nav.about")], ["destinations", t("nav.ports")], ["routes", t("nav.routes")], ["tracking", t("nav.tracking")], ["quote", t("nav.quote")], ["billing", t("nav.billing")]].map(([id, label]) => (
              <button key={id} onClick={() => go(id)} className="block text-sm text-steel-300 hover:text-ember transition-colors duration-300">{label}</button>
            ))}
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-widest text-steel-500 mb-5">{t("footer.contact")}</p>
          <div className="space-y-2 text-sm text-steel-300">
            <p>{COMPANY.addressLine1}<br />{COMPANY.addressLine2}</p>
            <p className="font-mono">{COMPANY.phone}</p>
            <p className="font-mono">Fax : {COMPANY.fax}</p>
            <p className="font-mono break-all">{COMPANY.email}</p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 flex items-center justify-center gap-6 text-xs text-steel-600">
        <span>{t("footer.legal")}</span>
        <a href="/admin/login" data-testid="footer-admin-link" className="hover:text-ember transition-colors duration-300 uppercase tracking-widest">Admin</a>
      </div>
    </footer>
  );
};
